import { ResponseService } from './response.service';
import { LocalStorageService } from './../services/local-storage.service';
import { ReplaySubject } from 'rxjs/Rx';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class PaymentsService {

  private oPayments = new ReplaySubject(1);
  private oPaymentURL = new ReplaySubject(1);

  STATUS_ISSUED = 2;
  STATUS_PAYED = 3;

  constructor(
    private apiService: ApiService,
    private responseService: ResponseService,
    private localStorageService: LocalStorageService
  ) { }

  clearService ()
  {
      this.oPayments = new ReplaySubject(1);
  }

  // getPayments (contractID, paymentType) {
  //   let URL = '/company/' + this.localStorageService.get('company') + '/invoices';
  //   URL = (contractID !== '') ? URL + '?contract_id=' + contractID : URL;
  //   this.apiService.get(URL).subscribe(
  //     (response) => {
  //       const paymentData = this.responseService.success(false, response, 'invoices');
  //       let unPayed = [];
  //       for (let payment of paymentData) {
  //         if (payment.status == paymentType && !payment.blocked_payment) {
  //           unPayed.push(payment);
  //         }
  //       }
  //       this.oPayments.next(unPayed);
  //     },
  //     (error) => {
  //       this.oPayments = new ReplaySubject(1);
  //     }
  //   );
  //   return this.oPayments;
  // }

  getPayable(contractID) {
    let URL = '/company/' + this.localStorageService.get('company') + '/invoices';
    URL = (contractID !== '') ? URL + '?contract_id=' + contractID : URL;
    this.apiService.get(URL).subscribe(
      (response) => {
        const paymentData = this.responseService.success(false, response, 'invoices');
        let unPayed = [];
        for (let payment of paymentData) {
          if (payment.status == this.STATUS_ISSUED) {
            unPayed.push(payment);
          }
        }
        this.oPayments.next(unPayed);
      },
      (error) => {
        this.oPayments.next(false);
      }
    );
    return this.oPayments;
  }

  getNotPayable(contractID) {
    let URL = '/company/' + this.localStorageService.get('company') + '/invoices';
    URL = (contractID !== '') ? URL + '?contract_id=' + contractID : URL;
    this.apiService.get(URL).subscribe(
      (response) => {
        const paymentData = this.responseService.success(false, response, 'invoices').map(function (invoice) {
          invoice.period_start = invoice.period_start.replace(/-/g, "/");
          invoice.period_end = invoice.period_end.replace(/-/g, "/");
          return invoice;
        });
        let unPayed = [];
        for (let payment of paymentData) {
          if (payment.status == this.STATUS_PAYED || payment.blocked_payment) {
            unPayed.push(payment);
          }
        }
        this.oPayments.next(unPayed);
      },
      (error) => {
        this.oPayments = new ReplaySubject(1);
      }
    );
    return this.oPayments;
  }

  payProforma (accessToken) {
    this.apiService.get('/payment/' + accessToken).subscribe(
      (response) => {
        const redirect = this.responseService.success(false, response, 'redirect');
        this.oPaymentURL.next(redirect);
      },
      (error) => {
        this.oPaymentURL = new ReplaySubject(1);
      }
    );

    return this.oPaymentURL;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/payments.service.ts